/**
 * i18next Configuration
 * Internationalization setup for English, Portuguese, and Spanish
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from '../locales/en/translation.json';
import ptTranslation from '../locales/pt/translation.json';
import esTranslation from '../locales/es/translation.json';

// Language persistence key
const LANGUAGE_STORAGE_KEY = 'ponder-portal-language';

// Get saved language from localStorage or default to 'en'
const savedLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY) || 'en';

/**
 * Initialize i18next with English, Portuguese, and Spanish translations
 */
i18n
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
      pt: {
        translation: ptTranslation,
      },
      es: {
        translation: esTranslation,
      },
    },
    lng: savedLanguage, // Use saved language from localStorage
    fallbackLng: 'en', // Fallback language if translation is missing
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    debug: import.meta.env.DEV, // Enable debug mode in development
  });

// Save language to localStorage whenever it changes
i18n.on('languageChanged', (lng) => {
  localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
  console.log('[i18n] Language changed to:', lng);
});

export default i18n;
